// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RBe_","type":"styles_type__3INLP","choices":"styles_choices__1lwBX"};